export interface RecurringPeriod {
    textLabel: string;
    period: LastPeriods;
}

export enum LastPeriods {
    LastWeek = 0,
    Last7Days,
    Last4Weeks,
    LastMonth,
    LastThreeMonths,
    Last30Days,
    Last90Days,
    Week,
    Month,
    Quarter,
    LastFullWeek,
    LastFullMonth,
    LastFullQuarter,
}

export type OneOffOrRecurringPeriod = OneOffPeriod | RecurringPeriod;

export interface OneOffPeriod {
    period: LastPeriods;
    textLabel: string;
    fromDate: string;
    toDate: string;
}
